export default __webpack_public_path__ + "static/media/Background_00185.18d2c549.png";